module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: ['contact-list', _vm.isSelected ? 'selected' : ''],
    on: {
      "click": _vm.openChat
    }
  }, [_c('img', {
    staticClass: "contact-img",
    attrs: {
      "src": _vm.pictureUrl
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contact-box"
  }, [_c('div', {
    staticClass: "contact-content"
  }, [_c('div', {
    staticClass: "message-timestamp"
  }, [_vm._v(_vm._s(_vm.timeStamp))]), _vm._v(" "), _c('div', {
    staticClass: "contact-name"
  }, [_vm._v(_vm._s(_vm.fullName))]), _vm._v(" "), _c('div', {
    staticClass: "last-message"
  }, [_vm._v(_vm._s(_vm.lastMessage))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-136a6428","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/ChatListItem.vue
// module id = 460
// module chunks = 0